import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectSummaryQuestionsV2Domain = (state) =>
  state.get("summaryQuestionsV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectSummaryQuestionsV2Domain, (state) =>
    state.get("isLoading")
  )

export const makeSelectQuestionTypes = () =>
  createSelector(selectSummaryQuestionsV2Domain, (state) =>
    state.get("questionTypes")
  )

export const makeSelectTotalQuestions = () =>
  createSelector(selectSummaryQuestionsV2Domain, (state) =>
    state.get("totalQuestions")
  )

export { selectSummaryQuestionsV2Domain }
